<div class="beleg-actions" *ngIf="!inTransactionWizard">
  <jf-button
    [variant]="'ghost'"
    (doClick)="assignNewBeleg()"
    [icon]="'refresh'"
  >
    Beleg ändern
  </jf-button>
</div>
